import { combineReducers } from 'redux';
import { canvas, STATE_KEY as CANVAS_STATE_KEY } from './canvas';
import { isLoading, STATE_KEY as IS_LOADING_STATE_KEY } from './preview';
import { bookProperties, STATE_KEY as BOOK_PROPERTIES_STATE_KEY } from './bookProperties';
import { allowRender, STATE_KEY as ALLOW_RENDER } from './allowRender';
import { setAutoFill, STATE_KEY as SET_AUTO_FILL } from './setAutoFill';
import { addPageToViewed, STATE_KEY as ADD_PAGE_TO_VIEWED } from './addPageToViewed';
import { previewFinished, STATE_KEY as PREVIEW_STATE_KEY } from '../ui/previewFinished';
import { isOrder, STATE_KEY as ORDER_STATE_KEY } from '../ui/isOrder';
import { isSavedBook, STATE_KEY as IS_SAVED_BOOK_STATE_KEY } from '../ui/isSavedBook';
import { setWeddingTextStatus, STATE_KEY as WEDDING_STATE_KEY } from '../ui/weddingTextGenerated';

const editorUI = combineReducers({
  [CANVAS_STATE_KEY]: canvas,
  [IS_LOADING_STATE_KEY]: isLoading,
  [BOOK_PROPERTIES_STATE_KEY]: bookProperties,
  [ALLOW_RENDER]: allowRender,
  [SET_AUTO_FILL]: setAutoFill,
  [ADD_PAGE_TO_VIEWED]: addPageToViewed,
  [PREVIEW_STATE_KEY]: previewFinished,
  [ORDER_STATE_KEY]: isOrder,
  [IS_SAVED_BOOK_STATE_KEY]: isSavedBook,
  [WEDDING_STATE_KEY]: setWeddingTextStatus,
});

export default editorUI;



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/index.js